export default __webpack_public_path__ + "static/media/jumping5.a679e333.jpg";